/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ProblemR = t.interface({});

// optional attributes
const ProblemO = t.partial({
  detail: t.string,

  instance: t.string,

  status: t.Integer,

  title: t.string,

  type: t.string
});

export const Problem = t.intersection([ProblemR, ProblemO], "Problem");

export type Problem = t.TypeOf<typeof Problem>;
